export enum NfcType {
    STICKER = 'sticker',
    TOTEM = 'totem',
}
